<template>
  <div id="wrapper-dashboard-index">
    <b-container fluid class="p-0">
      <b-row no-gutters>
        <b-col lg="auto" class="col-left">
          <LmColumnMenu :menuItems="mainMenuItems"></LmColumnMenu>
        </b-col>
        <b-col class="col-right">
          <LmHeader />
          <router-view />
            <div class="no-search-found">
              <img src="@/assets/images/lumile-logo-no-search.png" alt="lumile-logo" />
              <h1>{{$t('401_message_h1')}}</h1>
              <h2>{{$t('401_message_h2')}}</h2>
            </div>
          <LmFooter />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LmColumnMenu from '@/components/LmColumnMenu.vue'
import LmHeader from '@/components/LmHeader.vue'
import LmFooter from '@/components/LmFooter.vue'

export default {
  computed: {
    ...mapState('settings', ['mainMenuItems', 'loading'])
  },
  methods: {
    ...mapActions('settings', ['getMainMenuSettings'])
  },
  created () {
    this.getMainMenuSettings()
  },
  components: {
    LmColumnMenu,
    LmHeader,
    LmFooter
  }
}
</script>

<style lang="sass" scoped>
  .col-right
    display: flex
    flex-direction: column
  .col-left
    flex: 0 1 235px
  .no-search-found
    padding: 5%
    img
      margin: 0 auto 30px auto
      display: block
      @media(max-width: $md)
        max-width: 50%
    h1,
    h2
      color: $primaryFontThemeColor
      max-width: 700px
      margin: 0 auto
      text-align: center
      @media(max-width: $md)
        min-width: 100px
    h1
      font-size: 24px
      margin-bottom: 10px
      @media(max-width: $md)
        font-size: 18px
    h2
      font-size: 18px
      @media(max-width: $md)
        font-size: 14px
</style>
